import { render } from "./index.vue?vue&type=template&id=d92eb6dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d92eb6dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d92eb6dc"],['__file',"src/views/ForgotPassword/SendResetRequest/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d92eb6dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d92eb6dc', __exports__)) {
    console.log('reload')
    api.reload('d92eb6dc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d92eb6dc&scoped=true", () => {
    console.log('re-render')
    api.rerender('d92eb6dc', render)
  })

}


export default __exports__